"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IPaper = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _IPaperWrapper = require("../../containers/IPaperWrapper");
var _hooks = require("../../hooks");
var _useCatalogueUrlAndId = require("../../hooks/useCatalogueUrlAndId");
var _useDisplay = require("../../hooks/useDisplay");
var _useIPaperInit = require("../../hooks/useIPaperInit");
var _usePageNumberContext = require("../../hooks/usePageNumberContext");
var _utils = require("../../utils");
var _Loading = require("../Loading");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('iframe')({
    border: 'none',
    boxSizing: 'border-box',
    height: '100%',
    width: '100%'
});
const IPaper = exports.IPaper = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { initialPage } = (0, _usePageNumberContext.usePageNumberContext)();
    const { catalogueUrl, isLoading: isLoadingCatalogueUrl } = (0, _useCatalogueUrlAndId.useCatalogueUrlAndId)();
    const { mainTitle } = (0, _hooks.useConfiguration)();
    const { getTestId } = (0, _testidGenerator.default)();
    const iframeRef = (0, _react.useRef)(null);
    const iframeLoaded = iframeRef.current !== null;
    // Initialize iPaper API
    (0, _useIPaperInit.useIPaperInit)(iframeLoaded);
    (0, _useDisplay.useDisplay)();
    // suffix "-brp" is needed to block eCatalogue basket on the page
    const fullCatalogueUrl = "".concat(catalogueUrl, "-brp?HideStandardUI=true&Page=").concat(initialPage);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_IPaperWrapper.IPaperWrapper, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.VisuallyHiddenTitle, {
                className: "visually-hidden",
                children: mainTitle
            }),
            isLoadingCatalogueUrl || !catalogueUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Loading.Loading, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
                ref: iframeRef,
                "data-ipaper": true,
                id: _utils.IPAPER_IFRAME_ID,
                "data-testid": getTestId(_constants.IPAPER),
                src: fullCatalogueUrl,
                title: "iPaper"
            })
        ]
    });
});
